import { Badge, Group, Text, Tooltip, UnstyledButton } from '@mantine/core';
import { IconCircleFilled, IconPhoneIncoming } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { useSoftphone } from '@/hooks/use-softphone';

export function PhoneStatusIndicator() {
  const { isConnected, activeCall, agentStatus, statusDefinitions } = useSoftphone();
  const currentDefinition = statusDefinitions.find((s) => s.name === agentStatus);

  const hasIncoming = activeCall?.state === 'ringing' && activeCall.direction === 'inbound';
  const statusColor = isConnected ? (currentDefinition?.color ?? 'gray') : 'gray';
  const label = hasIncoming
    ? 'Incoming'
    : isConnected
      ? (currentDefinition?.label ?? agentStatus ?? 'Online')
      : 'Offline';

  return (
    <Tooltip label={hasIncoming ? 'Incoming call — click to answer' : `Agent: ${label}`}>
      <UnstyledButton component={Link} to="/agent">
        <Group
          gap={6}
          px="sm"
          py={4}
          style={{
            borderRadius: 'var(--mantine-radius-xl)',
            backgroundColor: hasIncoming
              ? 'var(--mantine-color-green-light)'
              : isConnected
                ? `var(--mantine-color-${statusColor}-light)`
                : 'transparent',
            border: isConnected ? undefined : '1px solid var(--mantine-color-default-border)',
            transition: 'background-color 150ms ease',
          }}
        >
          {hasIncoming ? (
            <IconPhoneIncoming size={14} color="var(--mantine-color-green-6)" />
          ) : (
            <IconCircleFilled
              size={8}
              color={isConnected ? `var(--mantine-color-${statusColor}-6)` : 'var(--mantine-color-dimmed)'}
            />
          )}
          <Text size="xs" fw={600} c={hasIncoming ? 'green' : isConnected ? statusColor : 'dimmed'}>
            {label}
          </Text>
          {activeCall && activeCall.state === 'active' && (
            <Badge size="xs" color="green" variant="filled" circle>
              1
            </Badge>
          )}
        </Group>
      </UnstyledButton>
    </Tooltip>
  );
}
